exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scroll-container[data-v-32052b6e]{white-space:nowrap;position:relative;overflow:hidden;padding:0;width:100%}.scroll-container[data-v-32052b6e] .el-scrollbar__bar{bottom:0px}", ""]);

// exports
